import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IFile } from "../interface/IFile";
import { IBaseResponse } from "../interface/IBaseResponse";
import { saveByteArray } from "src/util/saveByteArray";
import { FilesCategoryEnum, FilesCategoryEnumLabel } from "../enum/FilesCategoryEnum";

enum FileServiceEnum {
  getAll = "/get-all?specialProjectId=",
  createOrUpdate = "/create-or-update",
  download = "/download",
  downloadTemplateDocument = "/template"
}

export default class FileService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/file");
  }

  public getAll = async (specialProjectId?: number): Promise<IFile[]> => await this.GET(`${FileServiceEnum.getAll}${specialProjectId ?? ""}`);
  public createOrUpdate = async (data: IFile): Promise<IBaseResponse> => await this.POST(FileServiceEnum.createOrUpdate, data);

  public download = async (file: IFile) => {
    const endpoint = FileServiceEnum.download + "?id=" + file.id;
    const data = await this.GET(endpoint, "blob");
    saveByteArray(file.fileName, data);
    return data;
  };

  public downloadTemplateDocument = async (category: FilesCategoryEnum) => {
    const filename = FilesCategoryEnumLabel.get(category) + ".xlsx";
    const endpoint = `${FileServiceEnum.downloadTemplateDocument}?documentCategory=${FilesCategoryEnum[category]}`;
    const data = await this.GET(endpoint, "blob");

    saveByteArray(filename, data);
    return data;
  };


}
